import RequestManager from '@ember-data/request';

import { LegacyNetworkHandler } from '@ember-data/legacy-compat';
import Fetch from '@ember-data/request/fetch';

export default class RequestManagerService extends RequestManager {
  constructor(...args) {
    super(...args);
    this.use([ LegacyNetworkHandler, Fetch ]);
  }
}
